module.exports = __webpack_public_path__ + "static/media/washington_arriere.dbe714df.jpg";